/**
 * @file: index.ts
 * @author: eric <eric.blueplus@gmail.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { StatusColors } from '@euler/components/Colors';
import { FontFamily } from '@euler/components/typography';
import {
  InspectionTaskEventSubType,
  InspectionTaskEventType,
} from '@euler/model/enum';
import { registerEventType } from '../../registry';

const register = registerEventType(InspectionTaskEventType.Construction);

function jobCommitted() {
  register(InspectionTaskEventSubType.ConstructionJobCommitted)(
    (item, data) => {
      item
        .label({
          text: `完成施工任务: ${data.jn}`,
          fontFamily: FontFamily.NotoSans.Medium,
          color: StatusColors.Success,
        })
        .medias('m');
    },
  );
}

function jobUpdated() {
  register(InspectionTaskEventSubType.ConstructionJobCommittedUpdated)(
    (item, data) => {
      item
        .label({
          text: `更新施工任务: ${data.jn}`,
          fontFamily: FontFamily.NotoSans.Medium,
          color: StatusColors.Success,
        })
        .medias('m');
    },
  );
}

function jobBegin() {
  register(InspectionTaskEventSubType.ConstructionJobBegin)((item, data) => {
    item.label({
      text: `开始施工任务: ${data}`,
      fontFamily: FontFamily.NotoSans.Medium,
      color: StatusColors.Info,
    });
  });
}

function jobCanceled() {
  register(InspectionTaskEventSubType.ConstructionJobCanceled)((item, data) => {
    item.label({
      text: `取消施工任务: ${data.jn}`,
      fontFamily: FontFamily.NotoSans.Medium,
      color: StatusColors.Danger,
    });
  });
}

function finished() {
  register(InspectionTaskEventSubType.ConstructionFinished)(item => {
    item.label('施工反馈已完成');
  });
}

function reportGenerated() {
  register(InspectionTaskEventSubType.ConstructionReportGenerated)(item => {
    item.label('推送施工报告');
  });
}

function reportUpdated() {
  register(InspectionTaskEventSubType.ConstructionReportUpdated)(item => {
    item.label('施工报告已更新');
  });
}

jobBegin();
jobCommitted();
jobUpdated();
jobCanceled();
finished();
reportGenerated();
reportUpdated();
